import { render } from "./AdminHome.vue?vue&type=template&id=6c1e663e"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"

import "./AdminHome.vue?vue&type=style&index=0&id=6c1e663e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__